module.exports = __webpack_public_path__ + "img/1095two1.38cbaa12.png";